import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Text from "../../components/ui/Text";

const SettingsPasswordCheckEmail = () => {
  const navigate = useNavigate();

  const handleGoToSignIn = () => {
    navigate("/signin");
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 2 }}>
      {/* Page Header */}
      <Text variant="pageHeader" sx={{ mb: "24px" }}>
        Check your email
      </Text>

      {/* Description */}
      <Text variant="paragraph">
        You should receive a link to reset your password.
      </Text>

      {/* Go to Sign In Button */}
      <Button
        variant="primary"
        onClick={handleGoToSignIn}
        sx={{ width: "100%", mt: "40px" }}
      >
        Go to sign in
      </Button>
    </Container>
  );
};

export default SettingsPasswordCheckEmail;
